import { ServiceResult } from '../models';
import { RecipeUser } from '../models/recipe-users.models';
import ApiService from './api-service';

class RecipeUsersService extends ApiService {
  private static classInstance: RecipeUsersService;

  private constructor() {
    super('RecipeUsers');
  }

  public static getInstance(): RecipeUsersService {
    if (!this.classInstance) {
      this.classInstance = new RecipeUsersService();
    }
    return this.classInstance;
  }

  public getRecipeSharedUsers(viewAsCustomerId: string): ServiceResult<RecipeUser[]> {
    return this.get(`${this.baseUrl}/GetRecipeSharedUsers?viewAsCustomerId=${viewAsCustomerId}`);
  }

  public getRecipePrivateUsers(viewAsCustomerId: string, recipeHeaderId: string): ServiceResult<RecipeUser[]> {
    return this.get(
      `${this.baseUrl}/getRecipePrivateUsers?viewAsCustomerId=${viewAsCustomerId}&recipeHeaderId=${recipeHeaderId}`
    );
  }

  public getRecipeMenuPrivateUsers(viewAsCustomerId: string, recipeMenuHeaderId: string): ServiceResult<RecipeUser[]> {
    return this.get(
      `${this.baseUrl}/GetRecipeMenuPrivateUsers?viewAsCustomerId=${viewAsCustomerId}&recipeMenuHeaderId=${recipeMenuHeaderId}`
    );
  }
}

export default RecipeUsersService;
